import React from 'react';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';
import scorecolors from '../../styles/scoreColors';
import clsx from 'clsx';
import { get } from '../../lib/lodash';

const styles = makeStyles((theme) => ({
  container: {
    position: 'relative',
  },
  label: {
    fontSize: 14,
    position: 'absolute',
    left: -16,
    bottom: -20,
  },
  labelRight: {
    left: 'auto',
    right: -16,
  },
}));

const SliderWithStyles = styled(Slider)(({ theme }) => ({
  root: {
    color: colors.disabledGray,
    height: 3,
    padding: '13px 0',
  },
  '& .MuiSlider-thumb': {
    height: 40,
    width: 40,
    backgroundColor: '#fff',
    boxShadow: 'rgba(0,0,0,0.5) 0 2px 2px',
    
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: '#ccc 0 2px 3px 1px',
    },

    '& .value': {
      fontSize: 12,
      color: theme.palette.common.white
    },

    '&.thumb-1': {
      backgroundColor: scorecolors.score10,
    },
    '&.thumb-0': {
      backgroundColor: scorecolors.score0,
    },
  },
  active: {},
  '& .MuiSlider-track': {
    height: 0,
    color: colors.disabledGray,
  },
  '& .MuiSlider-rail': {
    color: colors.disabledGray,
    opacity: 1,
    height: 3,
  },
}));

const ThumbComponent = (props) => {
  const { children, ...other } = props;

  const di = get(props, 'data-index');
  const value = get(props, `ownerState.value.${di}`);

  return (
    <SliderThumb {...other} className={clsx(props.className, `thumb-${di}`)}>
      {children}
      <span className="value">{value}</span>
    </SliderThumb>
  )
};

export const ColorSlider = (props) => {
  const classes = styles();

  return (
    <div className={classes.container}>
      <SliderWithStyles {...props} slots={{ thumb: ThumbComponent }} />
      <div className={classes.label}>Low</div>
      <div className={clsx(classes.label, classes.labelRight)}>High</div>
    </div>
  );
};
